module.exports = __webpack_public_path__ + "static/sdtimes-91ece0ce0644fd096350a09a92bbf81d.png";